import {
  getOrdersOverviewApi,
  getOrdersApi,
  getOrderByIdApi,
  getOrdersSyncStatusApi,
  startOrdersSyncApi,
  getOrdersSettingsApi,
  updateOrdersSettingsApi,
} from './orders.api';

export const getOrdersOverviewReducers = (builder) => {
  builder
    .addCase(getOrdersOverviewApi.pending, (state) => {
      state.getOverviewStatus = 'pending';
      state.error = null;
    })
    .addCase(getOrdersOverviewApi.fulfilled, (state, { payload }) => {
      state.getOverviewStatus = 'fulfilled';
      state.overview = payload;
      state.error = null;
    })
    .addCase(getOrdersOverviewApi.rejected, (state, action) => {
      state.getOverviewStatus = 'rejected';
      state.error = action.payload?.message || action.error?.message;
    });
};

export const getOrdersReducers = (builder) => {
  builder
    .addCase(getOrdersApi.pending, (state) => {
      state.getOrdersStatus = 'pending';
      state.error = null;
    })
    .addCase(getOrdersApi.fulfilled, (state, { payload }) => {
      state.getOrdersStatus = 'fulfilled';
      state.orders = payload.orders || [];
      state.totalOrders = payload.pagination?.total ?? 0;
      state.totalPages = payload.pagination?.totalPages ?? 1;
      state.currentPage = payload.pagination?.page ?? 1;
      state.error = null;
    })
    .addCase(getOrdersApi.rejected, (state, action) => {
      state.getOrdersStatus = 'rejected';
      state.error = action.payload?.message || action.error?.message;
    });
};

export const getOrderByIdReducers = (builder) => {
  builder
    .addCase(getOrderByIdApi.pending, (state) => {
      state.getOrderByIdStatus = 'pending';
      state.currentOrder = null;
      state.error = null;
    })
    .addCase(getOrderByIdApi.fulfilled, (state, { payload }) => {
      state.getOrderByIdStatus = 'fulfilled';
      state.currentOrder = payload;
      state.error = null;
    })
    .addCase(getOrderByIdApi.rejected, (state, action) => {
      state.getOrderByIdStatus = 'rejected';
      state.currentOrder = null;
      state.error = action.payload?.message || action.error?.message;
    });
};

export const ordersSyncReducers = (builder) => {
  builder
    .addCase(getOrdersSyncStatusApi.fulfilled, (state, { payload }) => {
      state.syncStatus = payload;
      state.syncRunning = Boolean(payload?.isRunning);
      if (payload?.lastProgress) {
        const { updatedAt: _u, ...progress } = payload.lastProgress;
        state.syncProgress = progress;
      }
    })
    .addCase(startOrdersSyncApi.pending, (state) => {
      state.startSyncStatus = 'pending';
    })
    .addCase(startOrdersSyncApi.fulfilled, (state) => {
      state.startSyncStatus = 'fulfilled';
      state.syncRunning = true;
    })
    .addCase(startOrdersSyncApi.rejected, (state, action) => {
      state.startSyncStatus = 'rejected';
      state.error = action.payload?.message || action.error?.message;
    });
};

export const ordersSettingsReducers = (builder) => {
  builder
    .addCase(getOrdersSettingsApi.fulfilled, (state, { payload }) => {
      state.settings = payload;
    })
    .addCase(updateOrdersSettingsApi.fulfilled, (state, { payload }) => {
      state.settings = payload;
    });
};
